// extracted by mini-css-extract-plugin
export default {"card":"card_card__cFY37","card2":"card_card2__HD60A","text":"card_text__UG1EM","text2":"card_text2__aFpA2"};